import { render, staticRenderFns } from "./SamParagraph.vue?vue&type=template&id=5da1e2c8&scoped=true&"
import script from "./SamParagraph.vue?vue&type=script&lang=js&"
export * from "./SamParagraph.vue?vue&type=script&lang=js&"
import style0 from "./SamParagraph.vue?vue&type=style&index=0&id=5da1e2c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1e2c8",
  null
  
)

export default component.exports